import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getClientLogsUrl } from "../utils/urlHelper";

const clientLogsApi = createApi({
  reducerPath: "clientLogs",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    clientLogs: builder.mutation({
      query: (body) => ({
        url: getClientLogsUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useClientLogsMutation,
} = clientLogsApi;

export { clientLogsApi };
